function changeIngredients(){
	let selectedIngredients = null;
	if (!!document.querySelectorAll('.section-ingredients-slider')) {
		document.querySelectorAll('.section-ingredients-slider').forEach(slide => {
			if (slide.classList.contains('is-selected')) {
				selectedIngredients = slide;
			}
		})
	}

	if (!!selectedIngredients) {
		if (!!selectedIngredients.getAttribute('data-identifier')) {
			let ingredientIdentifier = selectedIngredients.getAttribute('data-identifier');
			if(!!document.querySelectorAll('.ingredients--heading')){
				let ingredientsHeadings = document.querySelectorAll('.ingredients--heading');
				ingredientsHeadings.forEach(heading =>{
					if(heading.getAttribute('data-identifier') == ingredientIdentifier) {
						heading.classList.remove('hidden');
					}else {
						heading.classList.add('hidden');
					}
				})
			}
			if(!!document.querySelectorAll('.product-ingridients__wrapper')){
				let ingredientsColaps = document.querySelectorAll('.product-ingridients__wrapper');
				ingredientsColaps.forEach(ingredient =>{
					if(ingredient.getAttribute('data-identifier') == ingredientIdentifier) {
						ingredient.classList.remove('hidden');
					}else {
						ingredient.classList.add('hidden');
					}
				})
			}
		}
	}
}

window.addEventListener('flickity:slide-changed', e=>{
	setTimeout(() => {
		changeIngredients()
	}, 1500);
})